export enum MasterLocationConstants {
    API_KEY_VALUE = "9x31d53d3872898793915c03d206aeb056701909769214"
}